import { widget } from "@foretagsplatsen/widgetjs";
import CompanyBalanceChartWidget from "../shared/CompanyBalanceChartWidget.js";
import companyOverviewLegendWidget from "./companyOverviewLegendWidget.js";
import spinner from "../../core/elements/spinner/spinner.js";

/**
 * `companyOverviewWidget` displays an overview of the company
 * business, regarding assets, liabilities and the owner's
 * part.
 *
 * It shows the financial position of the company at the end of
 * the month. It shows the total assets and how it is financed
 * with liabilities and equity/owner's part.
 *
 * The legend displays the changes during the month for each part.
 *
 * @example
 * var companyOverview = companyOverviewWidget();
 * companyOverview.show(data);
 * @param {object} spec - Parameter object
 * @param {object} my - protected fields holder
 * @return {*}
 */
function companyOverviewWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.companyChart = undefined;

	my.companyOverviewLegend = companyOverviewLegendWidget();

	that.show = function (companyTransitionBalance) {
		const balance = companyTransitionBalance.closingBalance;

		my.companyChart = new CompanyBalanceChartWidget({
			dates: [balance.date],
			currentAssets: [balance.currentAssets],
			fixedAssets: [balance.fixedAssets],
			totalLiability: [balance.totalLiability],
			ownersPart: [balance.ownersPart],
		});

		my.companyOverviewLegend.setValues(companyTransitionBalance);
		this.update();
	};

	that.renderContentOn = function (html) {
		if (!my.companyChart) {
			spinner({ renderOn: html });
			return;
		}

		html.div(
			{ class: "col-lg-4 col-md-4 col-sm-4 nopadding" },
			my.companyChart,
		);

		html.div(
			{ class: "legend-container col-lg-8 col-md-8 col-sm-8 nopadding" },
			my.companyOverviewLegend,
		);
	};

	return that;
}

export default companyOverviewWidget;
